import { JsonRecipientModel, RecipientModel, RecipientModelFromJson } from '../low-level/recipient.model';
import {
    JsonRecipientListModelOptions,
    RecipientListModelOptions,
    RecipientListModelOptionsFromJson,
} from '../options/recipient-list-model-options';
import { ArrayModel, ODataArrayOutModel } from './array.model';

export class RecipientListModel extends ArrayModel<RecipientModel> {
    public constructor(
        name: string,
        entries: RecipientModel[],
        public options = new RecipientListModelOptions(),
    ) {
        super(name, entries, options);
    }

    /**
     * Iterate over internal models array and call outmodel conversion function for each of the models
     *
     * @returns {object} the outmodel representation of this array model
     */
    public getOutModel(): ODataRecipientListOutModel {
        const outModel: ODataRecipientListOutModel = {};
        outModel[this.name] = this.getSelectedRecipients().map((entry) => {
            return entry.getOutModel();
        });

        return outModel;
    }
    /**
     * This function will filter recipients based on isSelected flag true and isHidden false
     */
    public getSelectedRecipients(): RecipientModel[] {
        return this.value.filter((entry) => {
            return entry.isSelected.value && !entry.isHidden;
        });
    }
}

export class RecipientListModelFromJson extends RecipientListModel {
    public constructor(data: JsonRecipientListModel) {
        super(
            data.name,
            data.value.map((e) => new RecipientModelFromJson(e)),
            new RecipientListModelOptionsFromJson(),
        );
    }
}

export interface JsonRecipientListModel {
    name: string;
    value: JsonRecipientModel[];
    options: JsonRecipientListModelOptions;
}

// need here type because empty interfaces are not allowed
export type ODataRecipientListOutModel = ODataArrayOutModel;
